var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_160_12075)",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.43 1.982L18.3 10.957l2.256-5.29 9.874-3.685z",
    fill: "#E17726",
    stroke: "#E17726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.451 1.982l12.022 9.059-2.148-5.373-9.874-3.686zm23.612 20.81l-3.227 4.93 6.91 1.903 1.98-6.725-5.663-.108zM1.168 22.9l1.968 6.725 6.898-1.902-3.215-4.93-5.651.107z",
    fill: "#E27625",
    stroke: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.662 14.463l-1.92 2.896 6.839.312-.228-7.36-4.691 4.152zm13.558.001l-4.763-4.237-.156 7.444 6.838-.311-1.92-2.896zM10.033 27.723l4.14-1.999-3.564-2.776-.576 4.775zm8.676-1.999l4.127 1.999-.564-4.775-3.563 2.776z",
    fill: "#E27625",
    stroke: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.836 27.723l-4.127-1.999.336 2.68-.036 1.138 3.827-1.82zm-12.803 0l3.84 1.819-.024-1.137.323-2.68-4.139 1.998z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.945 21.177l-3.431-1.005 2.423-1.113 1.008 2.118zm4.991 0l1.007-2.118 2.436 1.113-3.444 1.005z",
    fill: "#233447",
    stroke: "#233447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.034 27.723l.6-4.93-3.816.107 3.216 4.823zm12.214-4.931l.588 4.93 3.227-4.822-3.815-.108zm2.892-5.432l-6.84.31.637 3.507 1.008-2.118 2.435 1.113 2.76-2.813zm-14.626 2.812l2.423-1.113 1.008 2.118.636-3.506-6.839-.312 2.772 2.813z",
    fill: "#CC6228",
    stroke: "#CC6228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.742 17.36l2.868 5.588-.096-2.776-2.772-2.813zm14.638 2.812l-.108 2.776 2.867-5.589-2.76 2.813zm-7.799-2.502l-.636 3.507.804 4.14.18-5.457-.348-2.19zm3.719 0l-.335 2.178.168 5.47.804-4.141-.636-3.507z",
    fill: "#E27525",
    stroke: "#E27525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.937 21.177l-.804 4.14.576.407 3.563-2.776.108-2.776-3.443 1.005zm-8.423-1.005l.096 2.776 3.563 2.776.576-.407-.804-4.14-3.431-1.005z",
    fill: "#F5841F",
    stroke: "#F5841F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.007 29.542l.036-1.137-.311-.263h-4.584l-.3.263.024 1.137-3.839-1.82 1.344 1.102 2.723 1.879h4.667l2.736-1.88 1.332-1.1-3.828 1.819z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.709 25.724l-.576-.407h-3.384l-.575.407-.324 2.68.3-.263h4.583l.312.264-.336-2.681z",
    fill: "#161616",
    stroke: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.947 11.544l1.02-4.955-1.536-4.607-11.722 8.676 4.511 3.806 6.37 1.854 1.404-1.64-.611-.442.971-.885-.743-.575.971-.742-.636-.49zM.916 6.59l1.032 4.954-.66.49.984.742-.744.575.972.885-.612.443 1.404 1.64 6.37-1.855 4.511-3.806L2.452 1.982.916 6.59z",
    fill: "#763E1A",
    stroke: "#763E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.59 16.318l-6.37-1.854 1.919 2.896-2.867 5.588 3.79-.048h5.664l-2.136-6.582zM9.662 14.464l-6.37 1.854L1.168 22.9h5.65l3.792.048-2.867-5.588 1.92-2.896zm8.639 3.206l.408-7.012 1.848-4.99h-8.23l1.847 4.99.408 7.013.156 2.202.012 5.445h3.383l.012-5.445.156-2.202z",
    fill: "#F5841F",
    stroke: "#F5841F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_160_12075"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5 .5)",
    d: "M0 0h32v32H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.eddf307ca48b91852dd01c896144e39e.svg";
export { ForwardRef as ReactComponent };